import { makeStyles } from '@mui/styles';
import { Button, Grid, Typography } from 'apollo-react';
import { neutral6, neutral7 } from 'apollo-react/colors';
import Download from 'apollo-react-icons/Download';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

import { useTranslation } from '../custom-hooks/useTranslation';

const useStyles = makeStyles({
  title: {
    fontSize: '24px',
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1,
    letterSpacing: 'normal',
    color: '#000',
    marginLeft: 17,
    padding: '24px 20px 18px 5px',
  },
  button: {
    '& svg': {
      fontSize: '50px !important',
    },
  },
});

const NavigationButton = ({ title, handleClick, rotateIcon }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  return (
    <Button
      variant="text"
      className={classes.button}
      icon={<Download sx={{ transform: rotateIcon }} />}
      onClick={handleClick}
      sx={{
        fontSize: 50,
        textTransform: 'none',
        color: neutral6,
        '&:hover': {
          textDecoration: 'underline',
          backgroundColor: 'transparent',
          color: neutral7,
        },
      }}
    >
      {translateString(title)}
    </Button>
  );
};

const AppMigration = () => {
  const classes = useStyles();
  const history = useHistory();
  const translateString = useTranslation();

  const handleNavigation = (newType) => {
    history.push(`/application-migration?type=${newType}`);
  };

  const handleExportClick = () => {
    handleNavigation('export');
  };

  const handleImportClick = () => {
    handleNavigation('import');
  };

  useEffect(() => {
    document.title = translateString('Application Migration');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography className={classes.title}>
          {translateString('Application Migration')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          style={{ height: '80vh', backgroundColor: '#fff' }}
        >
          <Grid item>
            <NavigationButton
              title="Export"
              handleClick={handleExportClick}
              rotateIcon="rotate(270deg)"
            />
          </Grid>
          <Grid item>
            <NavigationButton
              title="Import"
              handleClick={handleImportClick}
              rotateIcon="rotate(90deg)"
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AppMigration;
